import React from "react";
import $ from "jquery";
import * as omnimap from "../../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "../functions/callBackFunctions";
import MyContext from "../../../../../../api/context/my-context";

class CreateUserModal extends React.Component {
  static contextType = MyContext;
  constructor(props) {
    super(props);
    this.state = {
      naam: "",
      naamRequiredAlert: "",
      email: "",
      emailRequiredAlert: "",
      stateRolVoorUitvoering: false,
      rolVoorUitvoeringText: false,

      userRoles: [],
      roleForExecutionUser: [],
      roleForExecution: null,
      roleForExecutionId: null,
      roleForExecutionSelected: [
        "f2d5c526-20ae-4f5f-bd8c-b2100f9e142a",
        "7cd29e15-bb7c-4232-963d-1c44fbc4cd2d",
        "49bf5d8c-92b3-4b83-b384-1cf52876cabf",
      ],
      notSelected: [
        "413d4b93-f837-4bbd-9c1b-d12a28662999",
        "edbcb3db-fc9d-475c-965f-8d5f0d7f015c",
        "7571d177-862a-4bd0-8621-f6a6cfa600c2",
        "f2d5c526-20ae-4f5f-bd8c-b2100f9e142a",
        "7cd29e15-bb7c-4232-963d-1c44fbc4cd2d",
        "49bf5d8c-92b3-4b83-b384-1cf52876cabf",
      ],
      postRoles: [],
      selectedUserDetail: [],
      rolesModel: {
        roles: [],
      },
    };
    this.baseState = this.state;
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleEvent = this.handleEvent.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  /**
   * @returns contex'i döndürür
   */
  useContext() {
    const context = React.useContext(MyContext.Consumer);
    if (context === undefined) {
      throw new Error("useCount must be used within a CountProvider");
    }
    return context;
  }

  handleEvent() {}

  resetForm = async () => {
    await this.setState(this.baseState);
    await this.setState({
      rolesModel: {
        roles: [],
      },
      postRoles: [],
      rolVoorUitvoeringText: false,
    });
  };

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  async handleSubmit(event) {
    // event.preventDefault();
    $("#cover-spin").show(0);

    this.state.naam == ""
      ? await this.setState({ naamRequiredAlert: true })
      : await this.setState({ naamRequiredAlert: false });
    this.state.email == ""
      ? await this.setState({ emailRequiredAlert: true })
      : await this.setState({ emailRequiredAlert: false });

    var roles = this.state.postRoles;

    // roles.push(rolVoorUitvoering);

    if (!this.state.rolVoorUitvoeringText) {
      // postRole state'in de ki tüm id'leri tarayıp "Rol voor uitvoering"
      // =>> olanları listeden kaldırır ve seçilmiş olan rolün id'sini diziye ekler
      for (let i = 0; i < roles.length; i++) {
        for (let j = 0; j < this.state.roleForExecutionSelected.length; j++) {
          const element = this.state.roleForExecutionSelected[j];
          if (roles[i].identification == element) {
            roles.splice(i, 1);
            break;
          }
        }
      }
    }

    var _rolesModel = this.state.rolesModel;
    roles.forEach((element) => {
      _rolesModel.roles.push({ identification: element.identification });
    });
    if (
      this.state.naamRequiredAlert !== true &&
      this.state.emailRequiredAlert !== true
    ) {
      /**
       * * 1. adım kullanıcı bilgileri güncelleniyor.
       */
      var userModel = {
        identification: window.$catalog_users_selectedRow.identification,
        alias: this.state.naam,
        email: this.state.email,
        profile: {},
      };

      var data = await omnimap.UserApiAction(
        window.$catalog_users_selectedRow.identification,
        "PATCH",
        userModel,
        null,
        window.$catalog_users_token
      );
      /**
       * * 2. adım rollerin güncellenmesi:
       * *    - eğer 1. adım isteği olumlu dönerse bu adım işletilecek
       * *    - burada seçilmiş olan tüm roller servise gönderilir.
       */
      if (data.result.status === "OK") {
        var data = await omnimap.UserApiAction(
          window.$catalog_users_selectedRow.identification,
          "PUT",
          _rolesModel,
          true,
          window.$catalog_users_token
        );

        await CallBackFunctions.UserEditCallBack().then((result) => {
          var context = this.context;
          context.actions.spinnerToggle(false);
        });
      }
    } else {
      $("#cover-spin").hide(0);
    }
  }

  /**
   * * service tarafından tüm roller burada çekilir
   * * ekrana yanıtılmayacak olan roller burada filtrelenir.
   */
  async getUserRoles() {
    $("#cover-spin").show(0);

    let selectUserDetail = await omnimap.UserApiAction(
      window.$catalog_users_selectedRow.identification,
      "GET",
      null,
      null,
      window.$catalog_users_token
    );

    let _userRoles = await omnimap.GetUserRolesAction(
      1,
      100,
      window.$catalog_users_token
    );

    var lastUserModel = [];
    var _roleForExecutionSelected = [];
    var _roleForExecutionSelected2 = [];

    var selectedIds = [];
    for (let y = 0; y < _userRoles.data.length; y++) {
      const user = _userRoles.data[y];

      selectedIds.push(user.identification);
    }

    var difference = selectedIds.filter(
      (x) => this.state.notSelected.indexOf(x) === -1
    );

    for (let i = 0; i < _userRoles.data.length; i++) {
      const user = _userRoles.data[i];

      for (let j = 0; j < difference.length; j++) {
        const userNotSelected = difference[j];
        if (userNotSelected === user.identification) {
          let model = {
            name: user.name,
            id: user.identification,
            selected: false,
          };
          await lastUserModel.push(model);
          break;
        }
      }

      for (let w = 0; w < this.state.roleForExecutionSelected.length; w++) {
        const _roleForExecutionUser = this.state.roleForExecutionSelected[w];
        if (_roleForExecutionUser === user.identification) {
          let model = { name: user.name, id: user.identification };
          await _roleForExecutionSelected.push(model);
        }
      }
    }

    /**
     * * role for execution kayıtlı özellikler burada eklenir.
     * * (dropdown daki roller)
     */
    for (let i = 0; i < this.state.roleForExecutionSelected.length; i++) {
      const allRole = this.state.roleForExecutionSelected[i];
      for (
        let j = 0;
        j < selectUserDetail.data.relationships.roles.length;
        j++
      ) {
        const userSavedRole = selectUserDetail.data.relationships.roles[j];

        if (userSavedRole.role.identification === allRole) {
          let model = {
            name: userSavedRole.role.name,
            id: userSavedRole.role.identification,
          };
          _roleForExecutionSelected2.push(model);
          let _postRole = this.state.postRoles;
          _postRole.push({
            identification: userSavedRole.role.identification,
          });
          this.setState({ postRoles: _postRole, rolVoorUitvoeringText: true });
          break;
        }
      }
    }
    /**
     * * kayıtlı özellikler burada eklenir.
     */
    for (let i = 0; i < lastUserModel.length; i++) {
      const allRole = lastUserModel[i];
      for (
        let j = 0;
        j < selectUserDetail.data.relationships.roles.length;
        j++
      ) {
        const selectedDetail = selectUserDetail.data.relationships.roles[j];
        if (allRole.id == selectedDetail.role.identification) {
          lastUserModel[i].selected = true;

          let _postRole = this.state.postRoles;
          _postRole.push({
            identification: selectedDetail.role.identification,
          });
          this.setState({ postRoles: _postRole });

          break;
        }
      }
    }

    await this.setState({
      userRoles: lastUserModel,
      roleForExecutionUser: _roleForExecutionSelected,
      roleForExecution: this.state.rolVoorUitvoeringText
        ? _roleForExecutionSelected2[0].name
        : null,
      roleForExecutionId: this.state.rolVoorUitvoeringText
        ? _roleForExecutionSelected2[0].id
        : null,
      selectedUserDetail: selectUserDetail.data,
      naam: selectUserDetail.data.alias,
      email: selectUserDetail.data.email,
    });

    $("#cover-spin").hide(0);
  }

  /**
   * *
   * @param {dropdown'da seçilmiş olan rolün id'si} id
   * @param {input event'i} e
   */
  async handleRoleForExecutionUser(id, e) {
    const element = e.target;

    let swap = this.state.postRoles;

    // postRole state'in de ki tüm id'leri tarayıp "Rol voor uitvoering"
    // =>> olanları listeden kaldırır ve seçilmiş olan rolün id'sini diziye ekler
    for (let i = 0; i < swap.length; i++) {
      for (let j = 0; j < this.state.roleForExecutionSelected.length; j++) {
        const element = this.state.roleForExecutionSelected[j];
        if (swap[i].identification == element) {
          swap.splice(i, 1);
          break;
        }
      }
      await this.setState({ postRoles: swap });
    }
    swap = await this.state.postRoles;
    let createModel = {
      identification: id,
    };
    swap.push(createModel);

    await this.setState({
      roleForExecution: element.name,
      roleForExecutionId: id,
      postRoles: swap,
    });
  }

  /**
   * * bu fonksiyon checkbox ile sıralanmış rollerin seçilme durumuna göre
   * * ... statelerini değiştirir.
   * @param {seçilmiş olan checkbox'ın tüm verilerini alır} selectRole
   * @param {onClick() event attribute'lerini alır} event
   */
  async handleChecboxUser(selectRole, event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;

    if (value === true) {
      // post edilecek method
      let createModel = {
        identification: selectRole.id,
      };
      let swap = this.state.postRoles;
      swap.push(createModel);
      this.setState({ postRoles: swap });
    } else {
      let swap = this.state.postRoles;
      /**
       * * seçilmiş veya seçimi kaldırılımış role burada filtrelenir
       */
      var _swap = await swap.filter((def) => {
        return def.identification !== selectRole.id;
      });
      await this.setState({ postRoles: _swap });
    }
  }

  async componentDidMount() {
    var that = this;
    $(document).on("click", "#user-edit-button", async () => {
      $("#edit-user-modal").modal("show");
      await that.resetForm();
      await that.getUserRoles();
    });
  }

  render() {
    this.handleEvent();

    return (
      <div
        className="modal fade"
        tabIndex={-1}
        role="dialog"
        id="edit-user-modal"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Gebruiker toevoegen</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div class="user-create-input-content">
                <input
                  type="text"
                  className="user-create-input-user"
                  placeholder="Naam"
                  autocomplete="off"
                  name="naam"
                  value={this.state.naam}
                  onChange={this.handleInputChange.bind(this)}
                />
              </div>
              <div class="user-create-input-content">
                <input
                  type="search"
                  className="user-create-input-user-email"
                  placeholder="e-mail"
                  autocomplete="off"
                  name="email"
                  value={this.state.email}
                  onChange={this.handleInputChange.bind(this)}
                />
              </div>

              <div className="modal-scroll">
                <label className="add-user-container role-text">
                  <div className="user-create-role-label role-text">
                    Rol voor uitvoering
                  </div>
                  <input
                    type="checkbox"
                    checked={this.state.rolVoorUitvoeringText ? true : false}
                    onClick={() =>
                      this.setState({
                        rolVoorUitvoeringText: !this.state
                          .rolVoorUitvoeringText,
                        stateRolVoorUitvoering: false,
                      })
                    }
                  />
                  <span className="add-user-checkmark" />
                </label>

                {/* <label className="user-create-role-label">
                  Rol voor uitvoering
                </label> */}
                <div
                  className={
                    this.state.stateRolVoorUitvoering
                      ? "user-create-input-content-role"
                      : "user-create-input-content-role"
                  }
                  onClick={() =>
                    this.setState({
                      stateRolVoorUitvoering: !this.state
                        .stateRolVoorUitvoering,
                    })
                  }
                  style={
                    this.state.rolVoorUitvoeringText
                      ? {}
                      : { pointerEvents: "none", opacity: "0.5" }
                  }
                >
                  <input
                    type="button"
                    className="user-create-input-user-role"
                    placeholder="Naam"
                    autocomplete="off"
                    value={
                      this.state.roleForExecution !== null
                        ? this.state.roleForExecution
                        : ""
                    }
                  />
                  <div class="popup-dropdown">
                    <span
                      className={
                        this.state.stateRolVoorUitvoering
                          ? "popuptext-dropdown show rolvooruitvoering"
                          : "popuptext-dropdown"
                      }
                    >
                      {this.state.roleForExecutionUser.map((m) => (
                        <a
                          class="popuptext-dropdown-a"
                          name={m.name}
                          onClick={this.handleRoleForExecutionUser.bind(
                            this,
                            m.id
                          )}
                        >
                          {m.name}
                        </a>
                      ))}
                    </span>
                  </div>
                </div>
              </div>
              <div className="modal-scroll">
                <label class="user-create-role-label">Gebruikersrollen</label>

                <div className="user-roles-content">
                  <div className="row clearfix user-roles">
                    {this.state.userRoles.map((m) => (
                      <div className="col-lg-6 text-center">
                        <label className="add-user-container">
                          <div className="add-user-container-title">
                            {m.name}
                          </div>
                          <input
                            type="checkbox"
                            onClick={this.handleChecboxUser.bind(this, m)}
                            defaultChecked={m.selected ? true : false}
                          />
                          <span className="add-user-checkmark" />
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              {/**
               * ileri status kullanılabilir
               */}
              {/* <div className="col-lg-4 text-center user-status">
                <div className="">
                  <div className="user-create-role-label">Status</div>
                  <label className="switch">
                    <input
                      id="e-beheereenheid_active"
                      type="checkbox"
                      defaultChecked={true}
                    />
                    <span className="slider-checkbox round" />
                  </label>
                </div>
              </div> */}
            </div>
            <div className="modal-footer">
              <MyContext.Consumer>
                {(context) => (
                  <button
                    type="button"
                    className="btn-modal"
                    onClick={(event) => {
                      context.actions.spinnerToggle(true);
                      this.handleSubmit();
                    }}
                  >
                    Verwerken
                  </button>
                )}
              </MyContext.Consumer>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CreateUserModal;
